import { render, staticRenderFns } from "./VitalsignSetting.vue?vue&type=template&id=775a1029&scoped=true&"
import script from "./VitalsignSetting.vue?vue&type=script&lang=ts&"
export * from "./VitalsignSetting.vue?vue&type=script&lang=ts&"
import style0 from "./VitalsignSetting.vue?vue&type=style&index=0&id=775a1029&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775a1029",
  null
  
)

export default component.exports